import { BodyRegular } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const VerificationFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VerificationFieldHelperText = styled.span`
  ${BodyRegular}
  font-size: 12px;
`;
